{
  "invitations": {
    "title": "Invitaciones de usuario",
    "dialogs": {
      "delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar esta invitación de usuario? No puede deshacer esta acción"
      }
    }
  }
}
